import React, { Component } from "react";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dialog } from "primereact/components/dialog/Dialog";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class ClientSites extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      siteList: [],
      siteSelected: false,
      siteEdited: false,
      siteAdded: false,
      siteDeleted: false,
      selectedSite: "",
      siteAddressLine1: "",
      siteAddressLine2: "",
      siteCodeTag: "",
      siteCustomerId: "",
      siteId: "",
      siteLastUpdatedDateTime: "",
      sitePostcode: "",
      siteDescription: "",
      siteName: "",
      siteTown: "",
      siteEmail: "",
      siteTelephone: "",
      editedSiteName: "",
      editedSiteAddressLine1: "",
      editedSiteAddressLine2: "",
      editedSitePostcode: "",
      editedSiteTown: "",
      editedSiteEmail: "",
      editedSiteTelephone: ""
    };
  }

  componentDidMount() {
    this.getSites();
  }

  getSites = async () => {
    this.setState({ loaded: false });

    let siteRequest = new CloudService.SiteRequest();
    siteRequest.codeTag = localStorage.getItem("codeTag");
    siteRequest.clientId = localStorage.getItem("clientId");
    siteRequest.userId = localStorage.getItem("userId");

    await api("siteApiV1SiteGetByClientId", siteRequest).then(res => {
      let siteResponse = CloudService.SiteResponse.constructFromObject(
        res.data
      );
      console.log(siteResponse);

      if (siteResponse.errorCode === 0) {
        this.setState({
          siteList: siteResponse.siteList
        });
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving data, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true });
  };

  editSite = async () => {
    this.setState({ loaded: false });

    let siteRequest = new CloudService.SiteRequest();
    siteRequest.codeTag = localStorage.getItem("codeTag");
    siteRequest.userId = localStorage.getItem("userId");
    siteRequest.id = this.state.siteId;
    siteRequest.lastUpdatedDateTime = this.state.siteLastUpdatedDateTime;
    siteRequest.siteName = this.state.editedSiteName;
    siteRequest.addressLine1 = this.state.editedSiteAddressLine1;
    siteRequest.addressLine2 = this.state.editedSiteAddressLine2;
    siteRequest.postcode = this.state.editedSitePostcode;
    siteRequest.town = this.state.editedSiteTown;
    siteRequest.email = this.state.editedSiteEmail;
    siteRequest.telephone = this.state.editedSiteTelephone;

    await api("siteApiV1SiteUpdate", siteRequest).then(res => {
      let siteResponse = CloudService.SiteResponse.constructFromObject(
        res.data
      );
      console.log(siteResponse);

      if (siteResponse.errorCode === 0) {
        this.setState({
          siteEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Site successfully updated",
          life: 3000
        });
        this.getSites();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the site, please try again",
          life: 3000
        });
      }
    });
  };

  addSite = async () => {
    this.setState({ loaded: false });

    let siteRequest = new CloudService.SiteRequest();
    siteRequest.codeTag = localStorage.getItem("codeTag");
    siteRequest.clientId = localStorage.getItem("clientId");
    siteRequest.userId = localStorage.getItem("userId");
    siteRequest.siteName = this.state.editedSiteName;
    siteRequest.addressLine1 = this.state.editedSiteAddressLine1;
    siteRequest.addressLine2 = this.state.editedSiteAddressLine2;
    siteRequest.postcode = this.state.editedSitePostcode;
    siteRequest.town = this.state.editedSiteTown;
    siteRequest.email = this.state.editedSiteEmail;
    siteRequest.telephone = this.state.editedSiteTelephone;

    await api("siteApiV1SiteCreate", siteRequest).then(res => {
      let siteResponse = CloudService.SiteResponse.constructFromObject(
        res.data
      );
      console.log(siteResponse);

      if (siteResponse.errorCode === 0) {
        this.setState({
          siteEdited: false,
          siteAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Site successfully created",
          life: 3000
        });
        this.getSites();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the site, please try again",
          life: 3000
        });
      }
    });
  };

  deleteSite = async () => {
    this.setState({ loaded: false });

    let siteRequest = new CloudService.SiteRequest();
    siteRequest.codeTag = localStorage.getItem("codeTag");
    siteRequest.userId = localStorage.getItem("userId");
    siteRequest.id = this.state.siteId;
    siteRequest.lastUpdatedDateTime = this.state.siteLastUpdatedDateTime;

    await api("siteApiV1SiteDelete", siteRequest).then(res => {
      let siteResponse = CloudService.SiteResponse.constructFromObject(
        res.data
      );
      console.log(siteResponse);

      if (siteResponse.errorCode === 0) {
        this.setState({
          siteSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Site successfully deleted",
          life: 3000
        });
        this.getSites();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the site, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <Dialog
          header="Delete Site"
          footer={
            <div>
              <Button
                label="Yes"
                onClick={() => {
                  this.setState({ siteDeleted: false });
                  this.deleteSite();
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#01a4ef"
                }}
              />
              <Button
                label="No"
                onClick={() => {
                  this.setState({ siteDeleted: false });
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#808080"
                }}
              />
            </div>
          }
          visible={this.state.siteDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ siteDeleted: false })}
        >
          Are you sure you want to delete?
        </Dialog>
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Sites Card*/}
            {this.state.siteSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Name: </b>
                    <label>{this.state.siteName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 1: </b>
                    <label>{this.state.siteAddressLine1 || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 2: </b>
                    <label>{this.state.siteAddressLine2 || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Postcode: </b>
                    <label>{this.state.sitePostcode || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>City: </b>
                    <label>{this.state.siteTown || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Email: </b>
                    <label>{this.state.siteEmail || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Contact Telephone: </b>
                    <label>{this.state.siteTelephone || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Edit"
                    onClick={() => {
                      this.setState({
                        siteSelected: false,
                        siteEdited: true,
                        siteAdded: false,
                        editedSiteName: this.state.siteName,
                        editedSiteAddressLine1: this.state.siteAddressLine1,
                        editedSiteAddressLine2: this.state.siteAddressLine2,
                        editedSitePostcode: this.state.sitePostcode,
                        editedSiteTown: this.state.siteTown,
                        editedSiteEmail: this.state.siteEmail,
                        editedSiteTelephone: this.state.siteTelephone
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ siteDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    className="secondary-btn"
                    label="View Buildings"
                    onClick={() => {
                      localStorage.setItem("siteId", this.state.siteId);
                      window.location = "#/clientBuildings";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Sites Card*/}
            {this.state.siteEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSiteName === "" ||
                          this.state.editedSiteName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSiteName || ""}
                        onChange={e =>
                          this.setState({
                            editedSiteName: e.target.value
                          })
                        }
                      />
                      <label>Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSiteAddressLine1 === "" ||
                          this.state.editedSiteAddressLine1 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSiteAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedSiteAddressLine1: e.target.value
                          })
                        }
                      />
                      <label>Address Line 1</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSiteAddressLine2 === "" ||
                          this.state.editedSiteAddressLine2 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSiteAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedSiteAddressLine2: e.target.value
                          })
                        }
                      />
                      <label>Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSitePostcode === "" ||
                          this.state.editedSitePostcode === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSitePostcode || ""}
                        onChange={e =>
                          this.setState({
                            editedSitePostcode: e.target.value
                          })
                        }
                      />
                      <label>Postcode</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSiteTown === "" ||
                          this.state.editedSiteTown === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSiteTown || ""}
                        onChange={e =>
                          this.setState({ editedSiteTown: e.target.value })
                        }
                      />
                      <label>City</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSiteEmail === "" ||
                          this.state.editedSiteEmail === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSiteEmail || ""}
                        onChange={e =>
                          this.setState({ editedSiteEmail: e.target.value })
                        }
                      />
                      <label>Email</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedSiteTelephone === "" ||
                          this.state.editedSiteTelephone === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedSiteTelephone || ""}
                        onChange={e =>
                          this.setState({
                            editedSiteTelephone: e.target.value
                          })
                        }
                      />
                      <label>Contact Telephone</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.state.siteAdded === true
                        ? this.addSite()
                        : this.editSite();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.state.siteAdded === true
                        ? this.setState({
                            siteSelected: false,
                            siteEdited: false,
                            siteAdded: false
                          })
                        : this.setState({
                            siteSelected: true,
                            siteEdited: false,
                            siteAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Sites Table*/}
            <div className="ui-g-12 card">
              <DataTable
                value={this.state.siteList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      siteSelected: true,
                      siteEdited: false,
                      siteAdded: false,
                      selectedSite: e.data,
                      siteAddressLine1: e.data.addressLine1,
                      siteAddressLine2: e.data.addressLine2,
                      siteCodeTag: e.data.codeTag,
                      siteCustomerId: e.data.customerId,
                      siteId: e.data.id,
                      siteLastUpdatedDateTime: e.data.lastUpdatedDateTime,
                      sitePostcode: e.data.postcode,
                      siteDescription: e.data.siteDescription,
                      siteName: e.data.siteName,
                      siteTown: e.data.town,
                      siteEmail: e.data.email,
                      siteTelephone: e.data.telephone
                    },
                    () => {
                      console.log(this.state.selectedSite);
                    }
                  );
                }}
                header="Sites"
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
                rows={10}
                emptyMessage="No Sites"
              >
                <Column
                  field="siteName"
                  header="Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine1"
                  header="Address Line 1"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine2"
                  header="Address Line 2"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="telephone"
                  header="Contact Telephone"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="town"
                  header="City"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </DataTable>
            </div>
            <div className="ui-g-12">
              <Button
                label="Create New"
                onClick={() => {
                  this.setState({
                    siteSelected: false,
                    siteEdited: true,
                    siteAdded: true,
                    editedSiteName: "",
                    editedSiteAddressLine1: "",
                    editedSiteAddressLine2: "",
                    editedSitePostcode: "",
                    editedSiteTown: "",
                    editedSiteEmail: "",
                    editedSiteTelephone: ""
                  });
                }}
                style={{ float: "right" }}
              />
              <Button
                className="secondary-btn"
                label="Back"
                onClick={() => {
                  window.location = "#/clients";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients/ClientSites.js